import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUploadPhotoAPIResponse } from '../../../models/upload.model';
import { BaseApiService } from '../../base-api/base-api.service';

@Injectable({
    providedIn: 'root',
})
export class UploadService extends BaseApiService {
    protected override endPoint = '/upload';

    uploadPhoto(file: FormData): Observable<IUploadPhotoAPIResponse> {
        return this.http.post<IUploadPhotoAPIResponse>(`${this.fullPath}/photo`, file);
    }
}
